import styles from "./AddItemButton.module.css";
import PropTypes from "prop-types";

/**
 *
 *  Button used for opening modals in the app
 *
 */

export function AddItemButton({ title, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer} onClick={onClick}>
        <div className={styles.verticalLine}></div>
        <div className={styles.horizontalLine}></div>
      </div>

      <div className={styles.title}>{title}</div>
    </div>
  );
}

AddItemButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};
